import React, { useState, useEffect } from 'react';

const FormEditMateria = ({ data, handleClose }) => {
    const [item, setItem] = useState({});

    useEffect(() => {
        if (data) {
            setItem({
                nombre: data.nombre || '',
                id_producto: data.id_producto || '',
               
                precio: data.precio || '',
                disponible: data.disponible ,
                imagen: data.imagen || null // Cambia a null para manejar correctamente la imagen
            });
        }
    }, [data]);

  



    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
    
        setItem((prevUser) => ({
          ...prevUser,
          [name]: type === 'file' ? files[0] : value,
        }));
      };
    

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('nombre', item.nombre);
       
        formData.append('precio', item.precio);
        formData.append('disponible', item.disponible);
        formData.append('imagen', item.imagen);

        fetch(`http://localhost:8080/api/producto/${item.id_producto}`, {
            method: 'PUT',
            headers: {
                'authorization': sessionStorage.getItem('token')
            },
            body: formData, // Enviar formData en lugar de JSON.stringify(item)
        })
            .then((response) => {
                if (response.ok) {
                    console.log('Elemento actualizado con éxito');
                    handleClose();
                } else {
                    console.error('Error al actualizar el elemento');
                }
            })
            .catch((error) => {
                console.error('Error de red:', error);
            });
    };

    return (
        <>
            <div className='container text-center'>
            </div>
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <form onSubmit={handleSubmit}>
                            <div className="form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="floatingMateria"
                                    value={item.nombre}
                                    placeholder='Nombre'
                                    onChange={handleInputChange}
                                    name='nombre'
                                    required
                                />
                                <label htmlFor="floatingMateria" ><h4>Nombre</h4></label>
                            </div>
                            <br></br>
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="floatingprecio"
                                    value={item.precio}
                                    placeholder='Precio'
                                    onChange={handleInputChange}
                                    name='precio'
                                    required
                                />
                                <label htmlFor="floatingprecio" ><h4>Precio</h4></label>
                            </div>
                         
                       
                            <br></br>
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    id="floatingdispo"
                                    value={item.disponible}
                                    onChange={handleInputChange}
                                    name='disponible'
                                    required
                                  
                                >
                                    <option value="">Seleccione una opción</option>
                                    <option value="0">Disponible</option>
                                    <option value="1">No disponible</option>

                                </select>
                                <label htmlFor="floatingdispo"><h4>Disponibilidad</h4></label>
                            </div>


                            <br></br>

                            <div className="form-floating">
                                <input
                                    type="file"
                                    className="form-control"
                                    id="floatingimagen"
                                    onChange={handleInputChange}
                                    name='imagen'
                                />
                                <label htmlFor="floatingimagen"><h4>Imagen</h4></label>
                            </div>
                            <br></br>
                            <button type="submit" className="btn btn-primary">Editar</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FormEditMateria;